import React, { useState } from "react";
import "../ProductsDetailsLower/Lower.css";
import jogger1 from "../assets/lower-4.png";
import jogger2 from "../assets/lower-4-b.png";
import jogger3 from "../assets/lower-4-c.png";
import { Link } from "react-router-dom";
const Lower4 = () => {
  const images = [jogger1, jogger2, jogger3];
  const [current, setCurrent] = useState(0);
  const [backgroundPos, setBackgroundPos] = useState("50% 50%");
  const [isMagnify, setIsMagnify] = useState(false);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setBackgroundPos(`${x}% ${y}%`);
  };

  return (
    <div className="joggers-page">
      <h1 className="joggers-title">Men’s Short & Lowers</h1>
      <div className="joggers-container">
        {/* Left side - Photo Grid */}
        <div className="joggers-gallery">
          <div
            className={`joggers-main ${isMagnify ? "magnify" : ""}`}
            style={{
              backgroundImage: isMagnify ? `url(${images[current]})` : "none",
              backgroundPosition: backgroundPos,
              backgroundSize: isMagnify ? "200%" : "cover",
            }}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => setIsMagnify(true)}
            onMouseLeave={() => setIsMagnify(false)}
          >
            <img
              src={images[current]}
              alt="Jogger"
              className="joggers-main-img"
            />
          </div>

          <div className="joggers-thumbnails">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Thumbnail ${index}`}
                className={`joggers-thumb ${current === index ? "active" : ""}`}
                onClick={() => setCurrent(index)}
              />
            ))}
          </div>
        </div>

        {/* Right side - Product Info */}
        <div className="joggers-info">
          <h2>Model No. MG-25725-11</h2>
          <button className="joggers-btn">
  <Link to="/contact" className="joggers-link">Contact Us</Link>
</button>
        </div>
      </div>
    </div>
  );
};

export default Lower4;
